import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {inviteUser, reset} from 'state/invite/inviteActions';
import ModalHeaderWithActions from 'components/ModalHeaderWithActions';

class InviteUserHeader extends React.Component {
  handleCancelClick = () => {
    this.props.reset();
    this.props.onCancel();
  };

  handleSendClick = () => {
    this.props
      .inviteUser()
      .then(this.props.reset)
      .then(this.props.onSend, () => {});
  };

  render() {
    return (
      <ModalHeaderWithActions
        onSend={this.handleSendClick}
        onCancel={this.handleCancelClick}
        cancelText={
          <FormattedMessage
            id="InviteUserHeader__Cancel"
            description="Cancel inviting user to Domo"
            defaultMessage="Cancel"
          />
        }
        title={
          <FormattedMessage
            id="InviteUserHeader__Title"
            description="Title of modal to invite a new user to Domo"
            defaultMessage="Invite to Domo"
          />
        }
        sendText={
          <FormattedMessage
            id="InviteUserHeader__Send"
            description="Send user invitation to Domo"
            defaultMessage="Send"
          />
        }
      />
    );
  }
}

InviteUserHeader.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
};
export default connect(
  null,
  {
    inviteUser,
    reset,
  }
)(InviteUserHeader);
